import React, { useEffect } from 'react';
import PropTypes from 'prop-types'

import { toggleProfileModal, toggleAuthModal, setAuthModal, goBack } from '../../actions/navActions';

// Redux
import { connect } from 'react-redux';

// Modals
import DefaultModal from './DefaultModal';
import ModalContainer from './ModalContainer';

// Components - imported
import { Button } from '@material-ui/core';
import AuthPage_Body from '../../pages/auth/AuthPage_Body';

// Icons - material UI
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import CreateIcon from '@material-ui/icons/Create';
import MailIcon from '@material-ui/icons/Mail';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocalMallIcon from '@material-ui/icons/LocalMall';

const AuthModal = ({ 
    auth,
    nav: { 
        authModal,
        authModalType,
        country_code,
        show_firewall,
        geo_loading
    },
    toggleProfileModal, 
    toggleAuthModal,
    setAuthModal,
    goBack
 }) => {


    useEffect(() => {
        
        if(auth.user && authModal) toggleAuthModal();

    }, [auth.user]);


    // --- Security Function --- 

    if(authModal && !geo_loading && (country_code !== 'US' || show_firewall)) {
        setAuthModal(false);
        window.location.href = '/404';
    }

    // --- END: Security Function --- 

    {/* Authentication Modal - if not logged in && triggered an Action */}
    return (
        <ModalContainer show={authModal} onClose={() => authModalType === 'search' ? goBack() : toggleAuthModal()}>
            <DefaultModal>
                <div className="closeBtn__container start transparent no_header">
                    <div onClick={() => authModalType === 'search' ? goBack() : toggleAuthModal()} className="closeBtn">
                        <CloseOutlinedIcon />
                    </div>
                </div>

                {/* Not Authenticated Action */}
                <div className="guest__action">
                    {/* Tried to: Create A Post */}
    
                        {/* Create Post Icon */}
                        {/* <div style={{marginBottom:'8px'}}>
                            <CreateIcon />
                        </div> */}

                        {/* Heart Icon */}
                        {/* <div style={{marginBottom:'8px'}}>
                            <FavoriteIcon />
                        </div> */}

                        {/* Comment Icon */}
                        {/* <div style={{marginBottom:'8px'}}>
                            <ChatBubbleIcon />
                        </div> */}

                        {/* Message Icon */}
                        {/* <div style={{marginBottom:'8px'}}>
                            <MailIcon />
                        </div> */}

                        {/* Bag Icon */}
                        {/* <div style={{marginBottom:'8px'}}>
                            <LocalMallIcon />
                        </div> */}
                        
                        {/* Modal Content */}
                        <div style={{width:'100%', margin:'32px'}}>

                            {authModalType === 'search' && (
                                <div style={{marginBottom:'16px', textAlign: 'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Start searching.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                        Once you sign up, you can start searching.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {authModalType === 'post' && (
                                <div style={{marginBottom:'16px', textAlign: 'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Create a post.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                        Once you sign up, you can create a post.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Tried to: Like post */}
                            {authModalType === 'like' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Like this post to share the love.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Sign Up now to like {auth.modalUser && `${auth.modalUser.first_name}'s`} post.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Tried to: Comment post */}
                            {authModalType === 'comment' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Comment to join the conversation.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Once you sign up, you can respond to {auth.modalUser && `${auth.modalUser.first_name}`}'s post.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Tried to: Message user */}
                            {authModalType === 'message' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Sign Up so you can message {/*{auth.modalUser && `${auth.modalUser.first_name}`}*/} privately.</span>
                                    </div>
                                    {/* <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Join Twitter now to let Sammy Roth know you like their Tweet.
                                        </span>
                                    </div> */}
                                </div>
                            )}

                            {/* Tried to: Message user */}
                            {authModalType === 'join campus' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Join Your Campus</span>
                                    </div>
                                    {/* <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Join Twitter now to let Sammy Roth know you like their Tweet.
                                        </span>
                                    </div> */}
                                </div>
                            )}

                            {/* Tried to: Comment on game */}
                            {authModalType === 'game comment' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Comment to join the conversation.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Once you sign up, you can comment on {auth.modalUser && `${auth.modalUser.first_name}`}'s game.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Tried to: Comment on project */}
                            {authModalType === 'project comment' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Comment to join the conversation.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Once you sign up, you can comment on {auth.modalUser && `${auth.modalUser.first_name}`}'s project.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Tried to: Like post a project */}
                            {authModalType === 'project like' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Like this project to share the love.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Sign Up now to like {auth.modalUser && `${auth.modalUser.first_name}'s`} project.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Tried to: Like post a game */}
                            {authModalType === 'game like' && (
                                <div style={{marginBottom:'16px', textAlign:'center'}}>
                                    {/* Modal Title */}
                                    <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                        <span>Like this game to share the love.</span>
                                    </div>
                                    {/* Modal Description */}
                                    <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                        <span>
                                            Sign Up now to like {auth.modalUser && `${auth.modalUser.first_name}'s`} game.
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Modal Actions */}

                            <AuthPage_Body source={authModalType} modal />
                    
                        </div>
                    
                    </div>
                
            </DefaultModal>
        </ModalContainer>
    )
}

AuthModal.propTypes = {
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    // Function to toggle the profile modal
    toggleProfileModal: PropTypes.func.isRequired,
    // Function to toggle the authentication modal
    toggleAuthModal: PropTypes.func.isRequired,
    setAuthModal: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    nav: state.nav
})

export default connect(mapStateToProps, { 
    // Connecting actions to the component
    toggleProfileModal, 
    toggleAuthModal,
    setAuthModal,
    goBack
})(AuthModal);


